/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>广告套餐设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;">
        <!-- <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary"
            icon="document" @click="dataSelect">刷新</el-button> -->
        <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document" @click="addNotice">新增</el-button> 
            <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document"><el-upload class="avatar-uploader" v-model="img"
             action="https://admin.shengqianxiong.com.cn/tao/upload" :show-file-list="false"
             :on-success="handleAvatarSuccess">新增</el-upload></el-button> -->
            <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
    </div>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id" @selection-change="handleSelectionChange">
        <el-table-column
        type="selection"
        width="55">
        </el-table-column>
			<!-- <el-table-column  prop="id" label="编号" width="80">
			</el-table-column> -->
			<el-table-column align="center" prop="gold" label="金币个数">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.gold" placeholder="请输入金币个数"></el-input>
                </template>
			</el-table-column>
            <el-table-column align="center" prop="money" label="金额(元)">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.money" placeholder="输入购买金额(最多二位小数)"></el-input>
                </template>
			</el-table-column>
			<!-- <el-table-column width="150px" prop="createTime"  label="创建时间">
			</el-table-column> -->
			
			<el-table-column align="center" label="操作" width="240px">
				<template slot-scope="scope">
					<el-button size="mini" type="primary"
						@click="updates(scope.$index, scope.row)">保存
					</el-button>
					<el-button size="mini" type="danger" 
						@click="deletes(scope.row.id)">删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>

    <el-dialog title="套餐添加" :visible.sync="dialogFormVisible" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">金币个数：</span>
        <el-input style="width:50%;" type="number" v-model="addForm.gold" placeholder="输入金币个数(整数数字)"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">金额：</span>
        <el-input style="width:50%;" type="number" v-model="addForm.money" placeholder="输入购买金额(最多二位小数)"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="releasNoticeTo()">添 加</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { addCarousel , deleteCarousel , getCarouselList } from '../../../api/manage/carousel.js'

import { addAdvertisingPackages , deleteAdvertisingPackages , getAdvertisingPackagesList , updateAdvertisingPackages } from '../../../api/manage/advertisingPackages.js'

import moment from 'moment';

export default {
  data() {
    return {
        multipleSelection: [],
        totalnum:0,
        page : 1 ,
        size : 10,
        tableDataLoading:false,
        dialogFormVisible:false,
        tableData:[],
        addForm:{
            gold:'',
            money:'',
        },
        updateForm:{
            
        },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    releasNoticeTo(){
        let post = addForm;
        addAdvertisingPackages(post).then((res) => {
            this.dialogFormVisible = false
            this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
                onClose: () => {
                    this.dataSelect()
                }
            });
        })

    },

    updates(index,row){
        console.log("row",row)
        updateAdvertisingPackages(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })
    },

    deletes(id){
      let obj = {
          id:id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAdvertisingPackages(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => {})
    },

    dataSelect(){
      let post = {
        // page : (this.page - 1 ) * this.size,
        // size : this.size
      }
      this.tableDataLoading = true
      getAdvertisingPackagesList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            // this.tableData = res.data.data;
            // res.data.data.forEach(item => {
            //   // console.log(item.createTime);
            //   item.createTime=moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
            //   // 
            // });
            this.tableData = res.data.data
            // console.log('this.tableDatathis.tableData',this.tableData)
            this.totalnum = res.data.count;
            return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })

    },

     // 添加分类弹框
    addNotice() {
        this.addForm = {
            gold:'',
            money:'',
        },
        this.dialogFormVisible = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/advertisingPackages/index.vue